<template>
  <div class="justify-center d-block pa-3 pa-md-6 pa-lg-12">
    <h1 class="display-1 mb-2">Votre inscription a bien été enregistrée.</h1>
    <p class="body-2">
      Vous pouvez retrouver votre facture sur votre espace membre dans l'onglet <a :href="urlFactures">Factures</a>.
    </p>
  </div>
</template>

<script>
import { getExtranetUrl } from "@/utils/stringUtils"

export default {
  data () {
    return {
      urlFactures: getExtranetUrl(process.env.VUE_APP_FACTURES_XTRANET),
    }
  },
}
</script>